import type { Translations } from "@eroad/types";

import type { BuildMessagesProps } from "./types";

/**
 * It combines locales into a new object, where each locale is mapped to its corresponding set of messages,
 * and en-NZ is the fallback.
 */
function buildMessages({ enAU, enNZ, enUS, frCA }: BuildMessagesProps): Translations {
  return {
    "en-AU": { ...enNZ, ...enAU },
    "en-NZ": enNZ,
    "en-US": { ...enNZ, ...enUS },
    "fr-CA": { ...enNZ, ...frCA },
  };
}

export { buildMessages };
export type { BuildMessagesProps } from "./types";
